import { useParams, useNavigate } from 'react-router';
import { Button, ArrowLeft } from '@t90/ui';

export function ArticlePage() {
  const { category, slug } = useParams<{ category: string; slug: string }>();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <Button
        variant="ghost"
        onClick={() => navigate(`/docs/${category}`)}
        className="gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to {category}
      </Button>

      <article className="prose-t90">
        <h1>{slug?.replace(/-/g, ' ')}</h1>
        <p className="text-muted-foreground">
          Article content will be loaded here. Content management is coming soon.
        </p>
      </article>
    </div>
  );
}
